import $ from 'jquery';
import DatePicker from './datePicker';
import String from './../helpers/string';
import 'jquery-mask-plugin';
import Loading from './loading';
import 'extensions/jquery/sortable'
import DataRules from './dataRules';

$.ajaxSetup({ cache: false });
['put', 'delete'].forEach(function (type) {
    $[type] = function (url, data) {
        return $.ajax({
            url: url,
            type: type.toUpperCase(),
            data: data ? JSON.stringify(data) : undefined,
            contentType: 'application/json'
        });
    };
});

$(function () {
    DatePicker.init($(document).find('[data-rules*="date"]'));
});

$(document).ajaxStart(function () {
    let loading = $(document).data('showLoading') !== false;
    if (loading)
        Loading.show('');
    $(document).data('showLoading', true);
}).ajaxStop(function () {
    Loading.hide();
}).on('ajaxError', function (e, xhr) {
    if (xhr.status === 401) {
        alert('Sessão expirada. Efetue o login novamente!');
        location.reload();
    }
}).on('keydown input blur', '[data-rules]', function (e) {
    var input: JQuery<HTMLElement> = $(e.currentTarget);

    if (input === null)
        return;

    var rules = DataRules.getRules(e.currentTarget),
        value = input.val() !== null ? (input.val().toString() || '').trim() : '',
        condition = false;

    for (var i = 0; i < rules.length; i++) {
        switch (rules[i].name) {
            case 'required':
                var empty = false;
                input.closest('.uk-form-controls')
                    .find('input, select, textarea')
                    .not('.select2-search__field')
                    .each(function () {
                        if (empty)
                            return;

                        const currentValue = $(this).val();

                        const inputValue = currentValue !== null
                            ? (currentValue.toString() || '').trim()
                            : '';

                        if (!inputValue)
                            empty = true;
                    });
                condition = DataRules.rule(e.currentTarget, empty, 'Campo obrigatório');
                break;
            case 'number':
                input.mask('#0', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && isNaN(+value), 'Número inválido');
                break;
            case 'decimal':
                input.mask('#0.00', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && isNaN(+value), 'Número inválido');
                break;
            case 'money':
                input.mask('000.000.000.000.000,00', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && String.hasLetters(value), 'Número inválido');
                break;
            case 'money-int':
                input.mask('000.000.000.000.000', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && String.hasLetters(value), 'Número inválido');
                break;
            case 'percent':
                input.mask('#0.00%', { reverse: true });
                condition = DataRules.rule(e.currentTarget, (value.replace('%', '')) && isNaN(+(value.replace('%', ''))), 'Número inválido');
                break;
            case 'date':
                condition = DataRules.rule(e.currentTarget, value && !String.isValidDate(value), 'Data inválida');
                break;
            case 'email':
                condition = DataRules.rule(e.currentTarget, value && !String.isValidEmail(value), 'E-mail inválido');
                break;
            case 'cpf':
                input.mask('000.000.000-00', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && !String.isValidCpf(value), 'CPF inválido');
                break;
            case 'cnpj':
                input.mask('00.000.000/0000-00', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && !String.isValidCnpj(value), 'CNPJ inválido');
                break;
            case 'fone':
                if (!value || value.length <= 14)
                    input.mask('(00) 0000-00009');
                else
                    input.mask('(00) 00000-0000');
                condition = DataRules.rule(e.currentTarget, value && value.length < 14, 'Telefone inválido');
                break;
            case 'cep':
                input.mask('00000-000', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && !String.isValidCep(value), 'CEP inválido');
                break;
            case 'autos-numero-cnj':
                /*
                input.mask('Z', {
                    translation: {
                        'Z': { pattern: /[0-9\.\-]/, recursive: true }
                    }
                });
                condition = DataRules.rule(e.currentTarget, value && !/^[0-9.\-]+$/.test(value), 'Autos Nº inválido');
                */
                input.mask('0000000-00.0000.0.00.0000');
                condition = DataRules.rule(e.currentTarget, value && !/^\d{7}-\d{2}\.\d{4}\.\d\.\d{1,2}\.\d{4}$/.test(value), 'Autos Nº inválido');
                break;
            case 'autos-numero-stj':
                input.mask('0000000/AA(0000/0000000-0)', {
                    translation: {
                        'A': { pattern: /[A-Za-z]/ }
                    }
                });
                condition = DataRules.rule(e.currentTarget, value && !/^\d+\/[A-Za-z]{2}\(\d{4}\/\d{7}-\d\)$/.test(value), 'Autos Nº inválido');
                break;
            case 'autos-numero-stf':
                input.mask('0.000.000', { reverse: true });
                condition = DataRules.rule(e.currentTarget, value && !/^\d{1,3}(?:\.\d{3})*$/.test(value), 'Autos Nº inválido');
                break;
            case 'hora-minuto':
                input.mask('00:00');
                condition = DataRules.rule(e.currentTarget, value && !/^\d{2}:\d{2}$/.test(value), 'Hora inválida');
                break;
            case 'chave-externa':
                input.mask('Z', {
                    translation: {
                        'Z': { pattern: /[A-Za-z0-9\.\-]/, recursive: true }
                    }
                });
                const onlyDigits = value ? value.replace(/\D/g, '') : '';
                const hasTwoLetterPrefix = /^[A-Za-z]{2}/.test(value || '');
                condition = DataRules.rule(e.currentTarget, value && (!hasTwoLetterPrefix || onlyDigits.length < 5), 'Dossiê inválido');
                break;
            default:
                console.error('Invalid Rule: ' + rules[i].name);
                break;
        }

        if (condition)
            return;
    }
});

export default $;
